import React from 'react';
import { Navigate, Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop.jsx';
import HomePage from './pages/HomePage.jsx';
import ServicesPage from './pages/ServicesPage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import PrivacyPage from './pages/PrivacyPage.jsx';
import TermsPage from './pages/TermsPage.jsx';
import LogoShowcase from './components/LogoShowcase.jsx';
import { Toaster } from './components/ui/toaster.jsx';

function App() {
  return (
    <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/servicios" element={<ServicesPage />} />
          <Route path="/solicitar-evaluacion" element={<ContactPage />} />
          <Route path="/contacto" element={<Navigate to="/solicitar-evaluacion" replace />} />
          <Route path="/politica-privacidad" element={<PrivacyPage />} />
          <Route path="/terminos-condiciones" element={<TermsPage />} />
          <Route path="/brand" element={<LogoShowcase />} />
          
          {/* Legacy routes fallback */}
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<Navigate to="/solicitar-evaluacion" replace />} />
          
          <Route path="*" element={
            <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background">
              <h1 className="text-4xl font-bold mb-4 text-foreground">Página no encontrada</h1>
              <p className="text-muted-foreground mb-8">La página que buscas no existe o ha sido movida.</p>
              <a href="/" className="text-primary hover:underline font-medium">Volver al inicio</a>
            </div>
          } />
        </Routes>
      <Toaster />
    </Router>
  );
}

export default App;
